import React, { useEffect, useState } from "react";
import Button from "../common/Button/Button";
import api from "../../services/api";
import "./Learning.css";
import { useNavigate, useParams } from "react-router-dom";

const AddLearningModules = () => {

    const navigate = useNavigate();
    const { id } = useParams();

    const [learningModules, setLearningModules] = useState([]);
    const [chapters, setChapters] = useState([]);
    const [formData, setFormData] = useState({
        topicheading: "",
        content: "",
        moduleid: null,
        chapterid: null,
    });

    useEffect(() => {
        if (id) {
            api.get(`/learningmodule/${id}`)
                .then((res) => {
                    setFormData({
                        topicheading: res.data.topicheading,
                        content: res.data.content,
                        moduleid: res.data.moduleid,
                        chapterid: res.data.chapterid,
                    });
                })
                .catch((err) => console.error("Error loading module:", err));
        }
    }, [id]);


    useEffect(() => {
        // Fetch learning modules data
        api.get('/learningmodules')
            .then((response) => {
                // Handle successful response
                setLearningModules(response.data);
            })
            .catch((error) => {
                // Handle error
                console.error('Error fetching learning modules:', error);
            });
    }, []);

    useEffect(() => {
        // Fetch chapter data
        api.get('/chaptermaster')
            .then((response) => {
                // Handle successful response
                setChapters(response.data);
            })
            .catch((error) => {
                // Handle error
                console.error('Error fetching chapter data:', error);
            });
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "moduleimage") {
            setFormData((prev) => ({ ...prev, [name]: files[0] }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            topicheading: formData.topicheading,
            content: formData.content,
            moduleid: formData.moduleid,
            chapterid: formData.chapterid,
        };

        const apiCall = id
            ? api.put(`/learningmodule/${id}`, payload)
            : api.post(`/learningmodule`, payload);

        apiCall
            .then(() => navigate("/learningmodule"))
            .catch((error) => console.error("Error:", error));
    };


    return (
        <div className="moduleFormContainer">
            <div className="moduleFormCard">

                <h2 className="moduleFormTitle"> {id ? "Edit Learning Content" : "Create Learning Content"}</h2>

                <form onSubmit={handleSubmit} className="moduleForm">


                    <div className="formSection">
                        <div className="formGrid">
                            <div className="formGroup">
                                <label>Module</label>
                                <select
                                    name="moduleid"
                                    value={formData.moduleid || ""}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>Select Module</option>
                                    {learningModules.map((module) => (
                                        <option key={module.moduleid} value={module.moduleid}>
                                            {module.module_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="formGrid">
                            <div className="formGroup">
                                <label>Chapter</label>
                                <select
                                    name="chapterid"
                                    value={formData.chapterid || ""}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>Select Chapter</option>
                                    {chapters.map((chapter) => (
                                        <option key={chapter.chapterid} value={chapter.chapterid}>
                                            {chapter.chapter_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="formGrid">
                        <div className="formGroup">
                            <label>Topic Heading</label>
                            <input
                                type="text"
                                name="topicheading"
                                value={formData.topicheading}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="formGroup">
                            <label>Content</label>
                            <textarea
                                name="content"
                                value={formData.content}
                                onChange={handleChange}
                                required
                                style={{ minHeight: "5px" }}
                            />
                        </div>

                    </div>

                    <div className="formActions">
                        <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
                        <button type="button" className="backButton" onClick={() => navigate(-1)}>
                            Cancel
                        </button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default AddLearningModules;
